import { render, staticRenderFns } from "./GenericExportColumns.vue?vue&type=template&id=a4ad38d2&scoped=true"
import script from "./GenericExportColumns.vue?vue&type=script&lang=js"
export * from "./GenericExportColumns.vue?vue&type=script&lang=js"
import style0 from "./GenericExportColumns.vue?vue&type=style&index=0&id=a4ad38d2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4ad38d2",
  null
  
)

export default component.exports